import React from "react";

function JeuxCooperatifs(props) {
  return (
    <div>
      <h1>Temps de jeux coopératifs</h1>

      <div>
        Ce temps de jeux est composé de jeux de société coopératifs choisis en
        fonction de l’âge des participants. De plus, nous apportons au choix :
        Soit un espace avec une dizaine de grands jeux en bois soit deux grands
        espaces de faire-semblant (cuisine-nursery, cuisine marchande).
      </div>
      <div>
        Les jeux coopératifs encouragent la participation et l’entraide de
        chaque individu. Ils favorisent la communication, la créativité et
        délivre de la sensation de mise en échec.
      </div>
    </div>
  );
}

export default JeuxCooperatifs;
